import { toRelativeUrl } from "@okta/okta-auth-js";

export function getPostLoginPath(): string {
  const configured = import.meta.env.VITE_OKTA_POST_LOGIN_REDIRECT_URI || "/";

  if (configured.startsWith("http")) {
    try {
      return new URL(configured).pathname || "/";
    } catch {
      return "/";
    }
  }

  return configured.startsWith("/") ? configured : `/${configured}`;
}

export function toAppPath(uri: string | undefined, fallback = "/"): string {
  if (!uri) {
    return fallback;
  }

  if (uri.startsWith("http")) {
    try {
      return toRelativeUrl(uri, window.location.origin);
    } catch {
      return fallback;
    }
  }

  return uri.startsWith("/") ? uri : `/${uri}`;
}

const AUTH_ONLY_PATHS = ["/login", "/login/callback", "/logout"];

export function getSafePostAuthPath(uri?: string): string {
  const path = toAppPath(uri, getPostLoginPath());
  const isAuthOnlyPath = AUTH_ONLY_PATHS.some(
    (authPath) => path === authPath || path.startsWith(`${authPath}/`)
  );

  return isAuthOnlyPath ? getPostLoginPath() : path;
}

/** Prefer deep-link path saved by RequireAuth (`location.state.from`). */
export function getReturnPathFromRouterState(
  state: unknown,
  fallback = getPostLoginPath()
): string {
  const from = (state as { from?: { pathname?: string; search?: string } } | null)
    ?.from;
  if (!from?.pathname) {
    return getSafePostAuthPath(fallback);
  }
  return getSafePostAuthPath(`${from.pathname}${from.search || ""}`);
}
